<template>
  <div>
    <div class="overlay-div" v-on:click.stop="handleNegativeAnswer"></div>
    <customer-list
      :allowSelection="customerPopUp.allowSelection"
      :isRetailButtonActive="customerPopUp.isRetailButtonActive"
      @elementSelected="handleElementSelection"
      class="customer-pop-up background-color"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "customerPopUp",
  data() {
    return {};
  },
  created: function () {
    this.setSelectedPreFilters(this.customerPopUp.preFilters);
    this.setSelectedFilter(undefined);
    window.addEventListener(
      "keyup",
      function (e) {
        if (this.isBlurred) {
          return;
        }
        if (e.keyCode === 27) {
          this.handleNegativeAnswer();
        }
      }.bind(this)
    );
  },
  destroyed: function () {
    this.setSelectedPreFilters(undefined);
    this.setSelectedFilter(undefined);
  },
  computed: {
    ...mapGetters({
      customerPopUp: "customerModule/customerPopUp",
    }),
  },
  methods: {
    ...mapActions({
      setCustomerPopUp: "customerModule/setCustomerPopUp",
      setSelectedPreFilters: "customerModule/setSelectedPreFilters",
      setSelectedFilter: "customerModule/setSelectedFilter",
    }),
    handleNegativeAnswer: function () {
      if (this.customerPopUp.negativeCallback) {
        this.customerPopUp.negativeCallback();
      }
      this.setCustomerPopUp({ isOpen: false });
    },
    handleElementSelection(selectedElement) {
      if (this.customerPopUp.positiveCallback) {
        this.customerPopUp.positiveCallback({
          selectedElement: selectedElement,
        });
        this.setCustomerPopUp({ isOpen: false });
      }
    },
  },
};
</script>

<style lang="scss">
.customer-pop-up {
  border-radius: $border-radius-0;
  position: fixed;
  width: 80%;
  height: 80%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  // background-color: $dark-background-color;
  overflow-y: auto;
}
</style>
